import { FC, useContext } from 'react';
import { DateTime } from 'luxon';
import { context as DependencyContext } from '../context/dependency';
import { context as StateContext } from '../context/state';
import _LiftReportToolBar from '../component/compound/LiftReportToolBar';

type Props = { className?: string };

const LiftReportToolBar: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  const selectedLiftReport = state.liftReports.data?.find((liftReport) => {
    return liftReport.goal.id === state.selectedGoalId.data;
  });

  const liftReportDefaultFrom = selectedLiftReport?.activityPeriodFrom
    ? selectedLiftReport?.activityPeriodFrom
    : undefined;

  const liftReportDefaultTo = selectedLiftReport?.activityPeriodTo ? selectedLiftReport?.activityPeriodTo : undefined;

  return (
    <_LiftReportToolBar
      organizationId={state.lastAccessedOrganization.item?.id}
      onSelectFromPeriod={(date: DateTime | null) => {
        dependency.liftReportUsecase.setFromPeriod(date);
      }}
      onSelectToPeriod={(date: DateTime | null) => {
        dependency.liftReportUsecase.setToPeriod(date);
      }}
      liftReports={state.liftReports.data}
      goals={state.liftReports.data?.map((item) => item.goal)}
      selectedGoalId={state.selectedGoalId.data}
      loadingGoals={state.liftReports.fetching > 0 || state.lastAccessedOrganization.fetching > 0}
      onSelectGoal={(goalId: string | null) => {
        dependency.liftReportUsecase.setSelectedGoal(goalId);
      }}
      liftReportChartPeriod={state.liftReportChartSetting.period}
      liftReportDefaultFrom={liftReportDefaultFrom ? DateTime.fromISO(liftReportDefaultFrom) : undefined}
      liftReportDefaultTo={liftReportDefaultTo ? DateTime.fromISO(liftReportDefaultTo) : undefined}
      updateLiftReportPeriod={dependency.liftReportUsecase.updateLiftReportPeriod}
      createLiftReport={dependency.liftReportUsecase.createLiftReport}
      removeLiftReport={dependency.liftReportUsecase.removeLiftReport}
      messageDispatcher={dependency.messageDispatcher}
      className={className}
    />
  );
};

export default LiftReportToolBar;
